import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import styles from './styles.module.less';

import type { BarcodeWidget, WidgetPropertyInput, WidgetPropertyDefinition } from '../../../config';

const Content = ({ id, widget, updateWidget }: WidgetPropertyInput<BarcodeWidget>) => {
  return (
    <textarea className={styles.content} id={id} onChange={(e) => updateWidget({ content: e.target.value })} value={widget.content ?? ''} />
  );
};

export const ContentProperty: WidgetPropertyDefinition<BarcodeWidget> = {
  id: 'content',
  label: <FormattedMessage {...messages.label} />,
  Component: Content,
};
